import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';

const AppStoreCard = styled(Stack)`
	background-color: ${({theme}) => theme.palette.grey[100]};
	padding: 16px;
	border-radius: 8px;
	gap: 16px;
`;

const AppStoreTitle = styled(Stack)`
	color: ${({theme}) => theme.palette.customInfo.dark};
	flex-direction: row;
	gap: 8px;
	align-self: center;
`;

const StyledLink = styled('a')`
	display: block;
	flex: 1;
`;

export {AppStoreCard, AppStoreTitle, StyledLink};
